import { useEffect, useRef } from "react";
import RenderHtmlContent from "components/Chat/RenderHtmlContent";
import { formatDate } from "./helpers";
import { Role } from "globals/enums";

type MessageListProps = {
  chatMessages: any;
};

const FirebaseMessageList = (props: MessageListProps) => {
  const messageEl = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (messageEl && messageEl.current && props.chatMessages && props.chatMessages.length) {
      messageEl.current.scrollTop = messageEl.current.scrollHeight;
    }
  }, [props.chatMessages]);

  return (
    <div className="tvp-chatContent" ref={messageEl}>
      <ul>
        {props?.chatMessages.map((message: any) => {
          const role = message?.role?.replace(/\b\w/g, (char: string) => char.toUpperCase());
          if (message?.role !== "candidate") {
            return (
              <div className="tvp-msgHolder2" key={message.id}>
                <div
                  className="tvp-list2"
                  style={{ backgroundColor: role === Role.Alvy ? "#1F55D7" : "#3581F0" }}
                >
                  {message?.text && <RenderHtmlContent message={message.text} />}
                </div>
                <div className="tvp-msgDesc2">
                  <div className="tvp-msgRole">{role}</div>
                  <div className="tvp-timeStamp">{formatDate(message?.received_at)} </div>
                </div>
              </div>
            );
          } else {
            return (
              <div className="tvp-msgHolder1" key={message.id}>
                {message.text && (<div className="tvp-list1">{message.text}</div>)}
                {message.image_url && (
                  <div className="tvp-py-2 tvp-rounded-md">
                    <img
                      loading="lazy"
                      src={message.image_url}
                      className="tvp-w-full tvp-rounded-md"
                      alt="Candidate Image upload"
                    />
                  </div>
                )}
                <div className="tvp-msgDesc1">
                  <div className="tvp-msgRole">You</div>
                  <div className="tvp-timeStamp">
                    {message?.read_at
                      ? `${formatDate(message?.read_at)} | Read`
                      : message?.received_at
                      ? `${formatDate(message?.received_at)} | Delivered`
                      : `${formatDate(message?.created_at)} | Sent`}
                  </div>
                </div>
              </div>
            );
          }
        })}
      </ul>
    </div>
  );
};

export default FirebaseMessageList;
